import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useState } from 'react'
import { useLogin } from '../lib/admin-api'

export const Route = createFileRoute('/login')({
  component: LoginPage,
})

function LoginPage() {
  const [password, setPassword] = useState('')
  const login = useLogin()
  const navigate = useNavigate()

  const submit = (event: React.FormEvent) => {
    event.preventDefault()
    login.mutate(password, {
      onSuccess: () => navigate({ to: '/admin' }),
    })
  }

  return (
    <div className="grain flex min-h-dvh items-center justify-center px-6">
      <div className="aurora pointer-events-none absolute inset-x-0 top-0 h-80" />

      <form
        onSubmit={submit}
        className="relative w-full max-w-sm rounded-xl border border-line bg-surface-1/80 p-8 backdrop-blur"
      >
        <p className="font-mono text-[11px] tracking-[0.22em] text-accent uppercase">Admin</p>
        <h1 className="mt-3 font-display text-2xl font-semibold tracking-tight">Sign in</h1>
        <p className="mt-2 text-sm text-ink-soft">
          One password, set in the server environment.
        </p>

        <label htmlFor="password" className="mt-6 block text-xs font-medium text-ink-soft">
          Password
        </label>
        <input
          id="password"
          type="password"
          autoComplete="current-password"
          autoFocus
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          className="mt-2 w-full rounded-lg border border-line bg-surface-0 px-3 py-2.5 font-mono text-sm text-ink outline-none transition-colors placeholder:text-ink-muted focus:border-accent"
          placeholder="••••••••••••"
        />

        {login.isError ? (
          <p role="alert" className="mt-3 text-sm text-bad">
            {(login.error as Error).message}
          </p>
        ) : null}

        <button
          type="submit"
          disabled={login.isPending || password.length === 0}
          className="mt-5 w-full rounded-lg bg-accent px-4 py-2.5 text-sm font-semibold text-surface-0 transition-colors hover:bg-accent-strong disabled:cursor-not-allowed disabled:opacity-40"
        >
          {login.isPending ? 'Checking…' : 'Sign in'}
        </button>

        <a
          href="/"
          className="mt-4 block text-center text-xs text-ink-muted transition-colors hover:text-ink-soft"
        >
          Back to the catalog
        </a>
      </form>
    </div>
  )
}
